var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaims({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.412 4.423V3.11L8 2.168l-1.412.942v1.313L8 5.364l1.412-.941zm-1.883-.81L8 3.3l.47.314v.305L8 4.233l-.47-.314v-.305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.992 8.5-2.13-2.29a3.75 3.75 0 0 0 .903-2.444A3.77 3.77 0 0 0 8 0a3.77 3.77 0 0 0-3.765 3.766c0 .932.34 1.785.902 2.444L3.007 8.5 0 10.003v4.348L3.294 16l3.294-1.648V12.65h2.824v1.703L12.706 16 16 14.352v-4.348l-3.008-1.505zm-.286 2.68-1.771-.885 1.77-.886 1.772.886-1.771.886zM8 .943a2.827 2.827 0 0 1 2.824 2.824A2.827 2.827 0 0 1 8 6.591a2.827 2.827 0 0 1-2.824-2.825A2.827 2.827 0 0 1 8 .942zM3.294 11.18l-1.771-.886 1.771-.886 1.771.886-1.77.886zm-2.353-.124 1.883.941v2.714L.94 13.77v-2.713zm2.824 3.655v-2.714l1.882-.941v2.713l-1.882.942zm2.823-3.005v-1.703L4.067 8.743l1.766-1.899a3.754 3.754 0 0 0 4.334 0l1.766 1.899-2.521 1.26v1.704H6.588zm3.765-.65 1.882.941v2.714l-1.882-.942v-2.713zm2.823 3.655v-2.714l1.883-.941v2.713l-1.883.942z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaims);
export default __webpack_public_path__ + "static/media/claims.f6ac8ecaebc61b725f2127c05c3f50e1.svg";
export { ForwardRef as ReactComponent };